
import { defineComponent } from "vue";

import StudentsContent from "./components/StudentsContent.vue";

export default defineComponent({
  name: "StudentPage",
  components: {
    StudentsContent
  },
});
